/**
 * Maps lucide icon NAMES (as stored in MongoDB) to the actual icon components.
 * Used by section components to resolve `icon: "Sparkles"` (string) coming from
 * the CMS into the imported lucide component. If a name isn't recognised, the
 * caller's fallback default kicks in.
 */
import {
  Sparkles,
  Bot,
  BrainCircuit,
  Brain,
  Eye,
  Workflow,
  Plug,
  Stethoscope,
  Hotel,
  Factory,
  Store,
  Banknote,
  Building2,
  GraduationCap,
  Users,
  Award,
  Handshake,
  Monitor,
  Smartphone,
  BarChart3,
  ShoppingBag,
  Palette,
  ShieldCheck,
  Boxes,
  Truck,
  ShoppingCart,
  HeartPulse,
  Radio,
  Megaphone,
  Landmark,
  Briefcase,
  Code,
  Code2,
  Database,
  Target,
  Clock,
  Rocket,
  CheckCircle2,
  Lock,
  TrendingUp,
  LineChart,
  Search,
  Server,
  Settings,
  PenTool,
  Scale,
  Globe,
  Cpu,
  Zap,
  Package,
  Network,
  FileText,
  MessageSquare,
  Mic,
  Sliders,
  Cloud,
  Repeat,
  TestTube2,
  Layers,
  AlertCircle,
  Pill,
} from 'lucide-react';

export const ICON_MAP = {
  Sparkles,
  Bot,
  BrainCircuit,
  Brain,
  Eye,
  Workflow,
  Plug,
  Stethoscope,
  Hotel,
  Factory,
  Store,
  Banknote,
  Building2,
  GraduationCap,
  Users,
  Award,
  Handshake,
  Monitor,
  Smartphone,
  BarChart3,
  ShoppingBag,
  Palette,
  ShieldCheck,
  Boxes,
  Truck,
  ShoppingCart,
  HeartPulse,
  Radio,
  Megaphone,
  Landmark,
  Briefcase,
  Code,
  Code2,
  Database,
  Target,
  Clock,
  Rocket,
  CheckCircle2,
  Lock,
  TrendingUp,
  LineChart,
  Search,
  Server,
  Settings,
  PenTool,
  Scale,
  Globe,
  Cpu,
  Zap,
  Package,
  Network,
  FileText,
  MessageSquare,
  Mic,
  Sliders,
  Cloud,
  Repeat,
  TestTube2,
  Layers,
  AlertCircle,
  Pill,
};

export const ICON_NAMES = Object.keys(ICON_MAP).sort();

export function resolveIcon(name, fallback) {
  if (typeof name === 'function') return name; // already a component
  if (name && ICON_MAP[name]) return ICON_MAP[name];
  return fallback;
}